"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConnectedWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _appSagas = _interopRequireDefault(require("./store/appSagas"));
var _appReducer = _interopRequireDefault(require("./store/appReducer"));
var _App = _interopRequireDefault(require("./components/App"));
var _PropsContext = require("./context/PropsContext");
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = require("styled-components");
var _services = require("./services");
var _reactI18next = require("react-i18next");
var _i18n = _interopRequireDefault(require("./i18n"));
var _globals = _interopRequireDefault(require("./components/vfuk/globals"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// import { useSmapi } from './hooks/app/useSmapi';

var Widget = function Widget(props) {
  var config = props.config,
    i18n = props.i18n,
    language = props.language,
    __instanceId = props.__instanceId,
    __pageId = props.__pageId,
    marketingId = props.marketingId,
    addToCartCallback = props.addToCartCallback;
  var dispatch = (0, _reactRedux.useDispatch)();
  if (!language || !config) {
    return null;
  }

  // setup language
  if (config.language && config.language !== language) {
    dispatch({
      type: 'LANGUAGE_REQUEST',
      payload: config.language
    });
    return null;
  }

  // setup services
  (0, _services.setupServices)({
    config: config,
    i18n: i18n,
    marketingId: marketingId,
    addToCartCallback: addToCartCallback
  });

  //sec initial smappi instance
  // useSmapi();

  // setup assets
  var assetsPath = 'assets/ws10/';
  var ingressUrl = window.REACT_APP_GS_INGRESS_URL;
  var assetsLocation = ingressUrl ? "https://".concat(ingressUrl, "/").concat(assetsPath) : assetsPath;
  _r10SourceLibrary.themeWS10.globalStyles = _globals.default;
  _r10SourceLibrary.themeWS10.setBaseAssetLocation(assetsLocation);
  _r10SourceLibrary.themeWS10.setAssetLocations('fonts', 'fonts/');
  _r10SourceLibrary.themeWS10.setAssetLocations('icons', 'icons/');
  _r10SourceLibrary.themeWS10.setAssetLocations('logos', 'logos/');
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: _r10SourceLibrary.themeWS10
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.I18nextProvider, {
    i18n: _i18n.default
  }, /*#__PURE__*/_react.default.createElement(_PropsContext.PropsProvider, {
    widgetProps: {
      __instanceId: __instanceId,
      __pageId: __pageId
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.themeWS10.globalStyles, null), /*#__PURE__*/_react.default.createElement(_App.default, {
    instanceId: __instanceId,
    pageId: __pageId
  }))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    language: state.language.language
  };
};
var ConnectedWidget = (0, _reactRedux.connect)(mapStateToProps)(Widget);
exports.ConnectedWidget = ConnectedWidget;
var exported = ConnectedWidget;
var _default = exported;
exports.default = _default;
Widget.propTypes = {
  i18n: _propTypes.default.any,
  language: _propTypes.default.string,
  __instanceId: _propTypes.default.string,
  __pageId: _propTypes.default.string
};
exported.reducer = _appReducer.default;
exported.sagas = _appSagas.default;

// exported.middlewares = [logger];